<header class="guest-flow-header">
  @if (showBack) {
    <button
      type="button"
      class="guest-flow-header-back"
      [attr.aria-label]="backLabel"
      [title]="backLabel"
      (click)="back.emit()">
      <i [class]="'common.chevronLeft' | nogoshIcon" aria-hidden="true"></i>
    </button>
  }
  <h1 class="guest-flow-title">
    @if (titleClickable) {
      <button type="button" class="guest-flow-title-button" (click)="titleClick.emit()">
        {{ title }}
      </button>
    } @else {
      {{ title }}
    }
  </h1>
  <div class="guest-flow-header-actions"><ng-content></ng-content></div>
</header>
